import $axios from '@/store/axios-instance.js';

export default {
    state: {
        serviceStatusDictionaryList: null
    },
    mutations: {
        retrieveServiceStatusDictionaryList(state, entityList) {
            state.serviceStatusDictionaryList = entityList
        },
    },
    actions: {
        retrieveServiceStatusDictionaryList(context/*, payload*/) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .get('serviceStatuses/dictList')
                        .then(response => {
                            context.commit('retrieveServiceStatusDictionaryList', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
    },
    getters: {
        serviceStatusDictionaryList(state) {
            return state.serviceStatusDictionaryList ? state.serviceStatusDictionaryList : []
        },
    }
}